import React from 'react';
import { render } from 'react-dom';
import AdfsLogout from './webcommon/common/httpConnection/AdfsLogout';

export default (previousLocation) => {
    render(
        <div style={ { width: '100%', height: '100%' } }>
            <AdfsLogout
                refreshPath={ previousLocation ? previousLocation.path + previousLocation.search + previousLocation.hash : '/' }
                setRefreshPathWhenShown
            />
        </div>,
        document.getElementById('root')
    );
};
